import { WeighmentSitesAPI } from "api";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import WishListDisplayTable from "./WishListDisplayTable";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Customer"
                  className="py-2 mb-1"
                  {...register("customer")}
                  isInvalid={!!errors.customer}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.customer?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Product"
                  className="py-2 mb-1"
                  {...register("product")}
                  isInvalid={!!errors.product}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.product?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Variant"
                  className="py-2 mb-1"
                  {...register("variant")}
                  isInvalid={!!errors.variant}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.variant?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  className="py-2 mb-1"
                  {...register("addedAt")}
                  isInvalid={!!errors.addedAt}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.addedAt?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> */}
          </Row>
          <WishListDisplayTable />
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
